import { updateOnboardingBookingRulesApi as generatedUpdateOnboardingBookingRulesApi } from '../generated/onboarding/updateOnboardingBookingRules';

import { getOnboardProfileDraftApi } from './getOnboardProfileDraft';

const updateOnboardingBookingRulesApi = generatedUpdateOnboardingBookingRulesApi.enhanceEndpoints({
  endpoints: {
    updateOnboardingBookingRules: {
      invalidatesTags: ['Onboard'],
      onQueryStarted: async ({ body }, { dispatch, queryFulfilled }) => {
        const patchResult = dispatch(
          getOnboardProfileDraftApi.util.updateQueryData('getOnboardProfileDraft', undefined, (draft) => {
            draft.bookingRules = {
              ...draft.bookingRules,
              ...body,
            };

            if (draft.progress != null) {
              draft.progress.bookingRules = true;
            } else {
              draft.progress = { bookingRules: true };
            }
          }),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});

export const { useUpdateOnboardingBookingRulesMutation } = updateOnboardingBookingRulesApi;
